import React from 'react';
import { Download } from 'lucide-react';
import useFileDownload from '../../../../commonFn/useFileDownload';

const SettlementDownloadButton = ({
  format,
  event,
  fromDate,
  toDate,
  onDownload,
}) => {

  const url = `pdf/paytm-settlement-utr-report?` +
    `${fromDate ? `fromDate=${fromDate}` : ''}` +
    `${toDate ? `&toDate=${toDate}` : ''}` +
    `${event?.Event_Id ? `&eventId=${event.Event_Id}` : ''}` +
    `&format=`;

  const { downloadFile, loading } = useFileDownload({
    url,
    defaultFilename: `settlement_${event?.Event_Id || 'all'}_${fromDate}_${toDate}.pdf`
  });

  const isDateRangeValid = fromDate && toDate ;

  const handleClick = async () => {
    if (!isDateRangeValid) {
      alert('Please select both From Date and To Date');
      return;
    }

    await downloadFile(format);
    if (onDownload) onDownload();
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading || !isDateRangeValid}
      className={`px-4 py-2 text-sm text-white rounded-lg flex items-center gap-2 ${!isDateRangeValid
        ? 'bg-gray-400 cursor-not-allowed'
        : 'bg-blue-600 hover:bg-blue-700'
        }`}
    >
      {loading ? (
        <>
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          Downloading...
        </>
      ) : (
        <>
          <Download size={14} />
          Download Report
        </>
      )}
    </button>
  );
};

export default SettlementDownloadButton;